import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// Servicios
import { EmpleadosServicio } from '../../../services/empleado.service';
import { RutasService } from '../../../services/rutas.service';

declare var $: any;

@Component({
  selector: 'app-empleados-modal',
  templateUrl: './empleados-modal.component.html',
  styleUrls: ['./empleados-modal.component.css']
})
export class EmpleadosModalComponent implements OnInit {
  listaEmpleados: Array<any>;
  empleado: Object;
  loading: boolean;
  rutaAsignada = false;
  accion: string;
  @Input() ruta;

  constructor(
    public activeModal: NgbActiveModal,
    private empleadoService: EmpleadosServicio,
    private rutaService: RutasService
  ) { }

  ngOnInit() {
    this.cargarListaEmpleados();
  }

  cargarListaEmpleados() {
    this.loading = true;
    this.empleadoService.listaEmpleadoRutas('2', this.ruta.ID_RUTA).subscribe(res => {
      this.listaEmpleados = res;
      // console.log(res);
      // for (const empleado of res) {
      //   for (const ruta of empleado.rutas_asignadas) {
      //     if (ruta.ID_RUTA === this.ruta.ID_RUTA) {
      //       this.rutaAsignada = true;
      //     }
      //   }
      // }
      this.loading = false;
    });
  }

  confirmarAsignacionRuta(empleado: Object) {
    this.accion = (this.rutaAsignada ? 'revocarle' : 'asignarle');
   this.empleado = empleado;
  }

  revocarRutaEmpleado() {
    this.empleado = null;
  }

  asignarRutaEmpleado(ID_EMPLEADO) {
    this.loading = true;

    this.rutaService.asignarRutaEmpleado(this.ruta, ID_EMPLEADO, this.empleadoService.datosEmpleado.ID_EMPLEADO).subscribe(() => {
      this.loading = false;
      this.activeModal.close();
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/lista-empleados/empleados-modal.component.ts